import classNames from "classnames"

import { Badge, Icon } from "web/components"

export default function Accordion({
  title,
  notificationCount = 0,
  isOpen = true,
  onToggle,
  children,
}) {
  const containerClasses = classNames("flex flex-col", { open: isOpen })

  const headerClasses = classNames(
    "flex items-center space-x-4 justify-between p-1 rounded-md bg-gray-100"
  )

  const titleClasses = classNames(
    "flex-1 flex items-center space-x-2 font-medium cursor-pointer overflow-hidden"
  )

  const contentClasses = classNames({
    hidden: !isOpen,
  })
  const showBadge = notificationCount > 0

  return (
    <div className={containerClasses}>
      <header className={headerClasses} onClick={onToggle}>
        <div className={titleClasses}>
          <Icon
            width="16px"
            height="16px"
            name={isOpen ? "chevron-down" : "chevron-right"}
          />
          <div className="ml-2 flex min-w-0 shrink items-center space-x-2 text-sm">
            <p className="truncate">{title}</p>
            {showBadge && (
              <Badge badgeColour="bg-red-600">{notificationCount}</Badge>
            )}
          </div>
        </div>
      </header>
      <div className={contentClasses}>
        <div className="my-4 px-4">{children}</div>
      </div>
    </div>
  )
}
